<template>
    <div class="circle">
        <v-progress-circular
            :size="100"
            :width="15"
            color="#4866e0"
            indeterminate
        ></v-progress-circular>
    </div>
</template>

<style scoped>
.circle {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
}
</style>